import * as React from 'react'
import StoryblokService from 'utils/storyblok-service'
// eslint-disable-next-line import/no-cycle
import { media } from 'utils/transforms'
import AccordionComponent from './Accordion'

export const transformProps = (propsArg) => {
  const props = { ...propsArg }

  if (props.imageSrc) {
    props.backgroundMediaProps = media(props.imageSrc)

    delete props.imageSrc
  }

  if (props.text) {
    props.text = StoryblokService?.client?.richTextResolver?.render(props.text)
  }

  props.items = props.items.map((item) => ({
    ...item,
    details:
      typeof item.details === 'string'
        ? item.details?.replace(/\n/g, '<br />')
        : StoryblokService?.client?.richTextResolver?.render(item.details),
  }))

  return props
}
const Accordion = (props) => <AccordionComponent {...transformProps(props)} />

export default Accordion
